module.exports = __webpack_public_path__ + "854d835e7216d96c37e5489863b14640.png";